"use client";

import { c as _c } from "react/compiler-runtime";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/lib/utils";
const toggleVariants = cva("inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
  variants: {
    variant: {
      default: "bg-transparent",
      outline: "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground"
    },
    size: {
      default: "h-9 px-2 min-w-9",
      sm: "h-8 px-1.5 min-w-8",
      lg: "h-10 px-2.5 min-w-10"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
const Toggle = t0 => {
  const $ = _c(14);
  let className;
  let props;
  let ref;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      variant,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = size;
    $[5] = variant;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    size = $[4];
    variant = $[5];
  }
  let t1;
  if ($[6] !== className || $[7] !== size || $[8] !== variant) {
    t1 = cn(toggleVariants({
      variant,
      size,
      className
    }));
    $[6] = className;
    $[7] = size;
    $[8] = variant;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== props || $[11] !== ref || $[12] !== t1) {
    t2 = <TogglePrimitive.Root ref={ref} className={t1} {...props} />;
    $[10] = props;
    $[11] = ref;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};
Toggle.displayName = TogglePrimitive.Root.displayName;
export { Toggle, toggleVariants };